<template>
  <span
    :class="[
      $style.chip,
      {
        [$style['chip--rakuten']]: channel === Channel.Rakuten,
        [$style['chip--yahoo']]: channel === Channel.Yahoo,
        [$style['chip--sbi']]: channel === Channel.Sbi,
        [$style['chip--ponta']]: channel === Channel.Ponta,
        [$style['chip--okb']]: channel === Channel.Okb,
        [$style['chip--kiraboshi']]: channel === Channel.Kiraboshi,
        [$style['chip--400f']]:
          channel === Channel.FourHundredF ||
          channel === Channel.FourHundredFInsuranceComparison,
        [$style['chip--metlife']]: channel === Channel.MetLife,
        [$style['chip--hanasaku']]: channel === Channel.Hanasaku,
        [$style['chip--homado']]: channel === Channel.HokenNoMadoguchi,
        [$style['chip--smcc']]: channel === Channel.Smcc,
        [$style['chip--famipay']]: channel === Channel.Famipay,
        [$style['chip--rakutenInHouseAdvisor']]:
          channel === Channel.RakutenInHouseAdvisor,
        [$style['chip--zaikeiJutakuKinyu']]:
          channel === Channel.ZaikeiJutakuKinyu,
        [$style['chip--moneyForward']]: channel === Channel.MoneyForward,
      },
    ]"
  >
    {{ labelOf(channel) }}
  </span>
</template>

<script setup lang="ts">
import { Channel } from '@/types/schema.generated'
import { labelOf } from '@/models/channel/channel'

defineProps<{ channel: Channel }>()
</script>

<style lang="scss" module>
.chip {
  display: inline-block;
  padding: 2px 8px;
  border: 1px solid $color-border-accent-primary;
  background-color: $color-surface-accent-primary;
  border-radius: 4px;
  color: $color-text-and-object-high-emphasis-inverse;
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;

  &--rakuten {
    border-color: $color-third-party-rakuten;
    background-color: $color-third-party-rakuten;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--yahoo {
    border-color: $color-third-party-yahoo;
    background-color: $color-text-and-object-high-emphasis-inverse;
    color: $color-third-party-yahoo;
  }

  &--sbi {
    border-color: $color-third-party-sbi;
    background-color: $color-third-party-sbi;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--ponta {
    border-color: $color-third-party-ponta;
    background-color: $color-third-party-ponta;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--okb {
    border-color: $color-third-party-okb;
    background-color: $color-third-party-okb;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--kiraboshi {
    border-color: $color-third-party-kiraboshi;
    background-color: $color-third-party-kiraboshi;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--400f {
    border-color: $color-third-party-400f;
    background-color: $color-third-party-400f;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--metlife {
    border-color: $color-third-party-metlife;
    background-color: $color-third-party-metlife;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--hanasaku {
    border-color: $color-third-party-hanasaku;
    background-color: $color-third-party-hanasaku;
    color: #000000; // TODO: あとで色を決める
  }

  &--homado {
    border-color: $color-third-party-homado;
    background-color: $color-third-party-homado;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--smcc {
    border-color: $color-third-party-smcc;
    background-color: $color-third-party-smcc;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--famipay {
    border-color: $color-third-party-famipay;
    background-color: $color-third-party-famipay;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--rakutenInHouseAdvisor {
    border-color: $color-third-party-rakuten-in-house-advisor;
    background-color: $color-third-party-rakuten-in-house-advisor;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--zaikeiJutakuKinyu {
    border-color: $color-third-party-zaikei-jutaku-kinyu;
    background-color: $color-third-party-zaikei-jutaku-kinyu;
    color: $color-text-and-object-high-emphasis-inverse;
  }

  &--moneyForward {
    border-color: $color-third-party-money-forward;
    background-color: $color-third-party-money-forward;
    color: $color-text-and-object-high-emphasis-inverse;
  }
}
</style>
